import copy from 'copy-to-clipboard';
import React from 'react';
import { useDispatch } from 'react-redux';

import { DUPLICATE_ITEM_CLICK } from 'constants/events';
import { LOOM_URI } from 'constants/routes';
import { duplicateVideoCreator } from 'creators/video';
import * as analytics from 'utilities/analytics';

import Tooltip from 'components/ui-components/tooltip';

import styles from './styles.module.less';

export default props => {
  const dispatch = useDispatch();
  const { video } = props;
  const newName = `Copy of ${video.name}`;
  const onClick = e => {
    e.preventDefault();

    dispatch(duplicateVideoCreator(video.id, newName))
      .then(newVideo => {
        const url = `${LOOM_URI}/share/${newVideo.id}`;

        copy(url, { format: 'text/plain' });
        setTimeout(() => {
          window.open(url, '_blank');
        }, 1000);
      })
      .then(() => {
        analytics.track(DUPLICATE_ITEM_CLICK, {
          entity_id: video.id,
          entity_type: 'video',
          click_source: 'share-video',
        });
      });
  };

  return (
    <div className={styles.btn} onClick={onClick}>
      <Tooltip>Duplicate video</Tooltip>
    </div>
  );
};
